import { validateSomething, validateString50 } from "../Form/Validations";
import { resolveTipoReportes } from "./utils";

const validateForm = (values, props) => {
    const tipoReportes = resolveTipoReportes();
    const REPORTES_WITH_SECTOR = tipoReportes.filter(tipo => tipo.parameters.includes("SECTORES")).map(tipo => tipo.key);
    const REPORTES_WITH_EQUIPO = tipoReportes.filter(tipo => tipo.parameters.includes("EQUIPOS")).map(tipo => tipo.key);
    const REPORTES_WITH_CAMPO = tipoReportes.filter(tipo => tipo.parameters.includes("CAMPOS")).map(tipo => tipo.key);

    const errors = {};
    for (const [valueKey, value] of Object.entries(values) ){
        if (props.bulkInfo?.bulkEnabled && props.bulkInfo?.fieldToEdit !== valueKey) continue;

        const validateSomethingKeys = ["tipo_reporte", "periodo_reporte", "freq", "time"];
        if (values.freq === "weekly") validateSomethingKeys.push("day_of_week");
        else if (values.freq === "annually") validateSomethingKeys.push("day_of_year");
        else if (values.freq === "monthly") {
            validateSomethingKeys.push("monthly_check");
            // first radio button checked
            if (values.monthly_check === "last-day") { /* do nothing */}
            // second radio button checked
            else if (values.monthly_check === "day") validateSomethingKeys.push("day_of_month");
            // third radio button checked
            else if (values.monthly_check === "day-of-week") validateSomethingKeys.push("occurrence_in_week", "day_of_week");
        }
        
        let err;
        if (validateSomethingKeys.includes(valueKey)){
            err = validateSomething(value);
        }
        else if (["nombre"].includes(valueKey)){
            err = validateString50(value);
        }

        const emptyArrayValues = 
            (valueKey === "sectores" && REPORTES_WITH_SECTOR.includes(values.tipo_reporte) && !values[valueKey]?.length)
            || (valueKey === "equipos" && REPORTES_WITH_EQUIPO.includes(values.tipo_reporte) && !values[valueKey]?.length)
            || (valueKey === "campos" && REPORTES_WITH_CAMPO.includes(values.tipo_reporte) && !values[valueKey]?.length)            
            || (valueKey === "mails_envio_reporte" && !values[valueKey]?.length)

        if (emptyArrayValues) err = "validation.required"
       
        err && (errors[valueKey] = err);
    }
    return errors;
}

export { validateForm }